import React, { useMemo, memo } from 'react';
import { compose } from 'ramda';
import { clsx } from '@core/js/utils/classNames.util';
import { withComponent } from '@core/js/components/hocs/withComponent';
import { componentService } from '@core/js/services/component.service';
import * as Types from '@core/js/components/main/DefaultHeader/types';

import style from './DefaultHeader.scss';

// @theme
import { CommonHeader } from '@theme/js/components/main/DefaultHeader/components/CommonHeader/CommonHeader';

/*
    There is no reason for portal to have & override DesktopHeader / MobileHeader,
    as they're pretty similar to each other, and may be combined in one component.
*/

export const DefaultHeaderBare: React.FC<Types.DefaultHeaderProps> = ({ className, classname }) => {
    const classNames = useMemo((): string => clsx([
        classname, className, style.defaultHeader, 'page-header'
    ]), [className, classname]);

    return (
        <header className={`${classNames} cms-default-header`}>
            <CommonHeader /> {/* @theme */}
        </header>
    );
};

export const DefaultHeader = compose(
    memo,
    withComponent({ tkPrefix: 'playtech.mobile.system.' })
)(DefaultHeaderBare);

componentService.registerWebContentComponents({ DefaultHeader });
